import { Aside } from "../components/aside/Aside";
import { Main } from "../components/main/Main";

export const MainPage = () => {
  return (
    <div className="resume-container">
      <Aside />
      <Main />
    </div>
  );
};
